import { useEffect, useState } from 'react';

export function useOnlyClient(initial?: boolean) {
  const [render, setRender] = useState(initial ?? false);
  useEffect(() => {
    if (!render) setRender(true);
  }, []);
  return render;
}
